// @ts-check
import React, { Component, StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'utils/reduxFormWrapper';
import { getFormValues } from 'redux-form';
import convertFormToJSON from './convertFormToJSON';
import validateQuestionnaireAnswers from './validateQuestionnaireAnswers';
import initialValuesFromQuestionnaire from './initialValuesFromQuestionnaire';
import { updateVisible } from 'utils/questionnaireUtils';

// This is a simple stateless component that renders by calling the render prop. Completely generic
const Render = ({ render, ...props }) => render(props);

// This is a redux-form enabled version of Render. Adds all the redux-form capability,
// without specific details like form name, validation, etc. Instead, those are injected
// via props.
const FormifiedRender = reduxForm()(Render);

class UnconnectedQuestionnaireFormManager extends Component {
  // Transforms the formValues a bit and passes them to the consumer's saveQuestionnaire function.
  saveQuestionnaire = formValues => {
    const transformedValues = {
      ...formValues,
      questionnaire: convertFormToJSON(formValues, this.props.visibleQuestionnaire),
    };
    return this.props.saveQuestionnaire(transformedValues);
  };

  render() {
    const { questionnaire, referralProfile, ...rest } = this.props;
    return (
      <FormifiedRender
        onSubmit={this.saveQuestionnaire}
        validate={validateQuestionnaireAnswers}
        initialValues={{
          ...initialValuesFromQuestionnaire(questionnaire),
          referralProfile,
        }}
        questionnaire={questionnaire}
        {...rest}
      />
    );
  }
}

function referralProfileValueWithStatTextHACK(referralProfileValues, formAnswers) {
  const statValue =
    formAnswers && formAnswers.referralProfile && formAnswers.referralProfile.stat
      ? 'stat'
      : 'normal';
  return Object.assign(referralProfileValues, { stat: statValue });
}

function mapStateToProps(state, ownProps) {
  const { form, questionnaire, rulableReferralProfileValues } = ownProps;
  const formAnswers = getFormValues(form)(state);

  // NB: Slight hack. There are referralProfile values in the form (i.e. `stat`) that should
  //     be ruled based on the current form value. So merge that in.
  //     For the sake of documentation, this is related to `stat` method on ReferralProfileRuler
  const referralProfileValues = referralProfileValueWithStatTextHACK(
    rulableReferralProfileValues,
    formAnswers
  );

  return {
    visibleQuestionnaire: updateVisible(questionnaire, formAnswers, referralProfileValues),
  };
}

/** @typedef {{
  form: string,
  questionnaire: any,
  referralProfile: any,
  rulableReferralProfileValues: any,
  render: (renderProps: {visibleQuestionnaire: any, handleSubmit: any, submitting: boolean}) => JSX.Element
}} QuestionnaireFormManagerPropsType */

/** @type { Component<QuestionnaireFormManagerPropsType> } */
const QuestionnaireFormManager = connect(mapStateToProps)(UnconnectedQuestionnaireFormManager);

QuestionnaireFormManager.propTypes = {
  form: PropTypes.string.isRequired,
  questionnaire: PropTypes.object.isRequired,
  referralProfile: PropTypes.object.isRequired,
  rulableReferralProfileValues: PropTypes.object.isRequired,
  render: PropTypes.func.isRequired,
};

QuestionnaireFormManager.displayName = 'QuestionnaireFormManager';

export default QuestionnaireFormManager;
